import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DrawerFooterProps } from "../types";

function DrawerFooter({ className, ...props }: DrawerFooterProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <div
      data-slot="drawer-footer"
      className={cn("mt-auto flex flex-col gap-2 p-4", className, classes)}
      {...native}
    />
  );
}

DrawerFooter.displayName = "Drawer.Footer";

export default DrawerFooter;
